import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
} from 'react-router-dom'

import NotFoundPage from './pages/NotFoundPage'
// import AboutPage from './pages/AboutPage'
// import Layout from './layouts/Layout'
import PlaygroundPage from './pages/playground/PlaygroundPage'
import LoginPage from './pages/login/LoginPage'
import PrivateRoute from './components/PrivateRoute'
import LogoutPage from './pages/LogoutPage'
import ForgotPasswordPage from './pages/login/ForgotPasswordPage'
import RegisterPage from './pages/register/RegisterPage'
import RegisterWithEmailPage from './pages/register/RegisterWithEmailPage'
import SetupPage from './pages/setup/SetupPage'
import LoginRoute from './components/LoginRoute'
// import HomePage from './pages/home/HomePage'

import ResetPasswordPage from './pages/login/ResetPasswordPage'
import VerifyEmailPage from './pages/login/VerifyEmailPage'
import SubscriptionPage from './pages/billing/SubscriptionPage.jsx'

import LayoutHome from './layouts/LayoutHome'
import TransactionForm from './components/transactions/TransactionForm'
import ModelDetail from './components/model/ModelDetail'
import Models from './components/model/Models'
import AddVaultForm from './components/vault/AddVaultForm'
import EditVaultForm from './components/vault/EditVaultForm'
import EditGroupForm from './components/nonModalWindows/EditGroup'
import EditTransactionCategoryForm from './components/transactionCategory/EditTransactionCategoryForm'
import AddTransactionCategoryForm from './components/transactionCategory/AddTransactionCategoryForm'
import Creategroup from './components/groups/CreateGroup'
import MoneyPathsModal from '@/components/money-paths/MoneyPathsModal.tsx'
import MoneyPathFormModal from '@/components/money-paths/MoneyPathFormModal.tsx'
import MyTodosModal from './components/my-todos/MyTodosModal'
import TransactionListModal from './components/transactions/TransactionListModal'
import AccountPage from './pages/account/AccountPage'

export const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path="/" errorElement={<NotFoundPage />}>
      <Route path="setup" element={<SetupPage />} />
      <Route path="verify-email" element={<VerifyEmailPage />} />
      <Route element={<PrivateRoute />}>
        {/* <Route path="setup" element={<SetupPage />} /> */}
        <Route path="/" element={<LayoutHome home />} />

        <Route path="create-space" element={<SetupPage />} />

        <Route>
          <Route path="account" element={<AccountPage />} />
        </Route>

        <Route element={<LayoutHome modal />}>
          <Route path="money-paths">
            <Route index element={<MoneyPathsModal />} />
            <Route path="new" element={<MoneyPathFormModal />} />
            <Route path=":id/edit" element={<MoneyPathFormModal />} />
          </Route>

          <Route path="my-todos">
            <Route index element={<MyTodosModal />} />
          </Route>
        </Route>

        <Route element={<LayoutHome modalWithRightPanel />}>
          <Route path="transaction-list">
            <Route path="vaults/:vaultId">
              <Route
                path="transactions"
                element={<TransactionListModal showRightPanel={false} />}
              />
              <Route
                path="transactions"
                element={<TransactionListModal showRightPanel={true} />}
              >
                <Route
                  path="new"
                  element={<TransactionForm activeTab="new" />}
                />
                <Route
                  path=":transactionId/edit"
                  element={<TransactionForm activeTab="new" />}
                />
              </Route>
            </Route>

            <Route path="categories/:categoryId">
              <Route
                path="transactions"
                element={<TransactionListModal showRightPanel={false} />}
              />
              <Route
                path="transactions"
                element={<TransactionListModal showRightPanel={true} />}
              >
                {/* List category transactions */}
                {/* <Route index element={<TransactionForm activeTab="list" />} /> */}
                <Route
                  path="new"
                  element={<TransactionForm activeTab="new" />}
                />
                <Route
                  path=":transactionId/edit"
                  element={<TransactionForm activeTab="new" />}
                />
              </Route>
            </Route>
          </Route>
        </Route>

        <Route element={<LayoutHome />}>
          {/* create new category */}
          {/* <Route
            path="categories/new" //?type="in|out"
            element={<TransactionForm type="income" activeTab="new" />}
          /> */}

          {/* ?type=vault|category */}
          <Route path="groups">
            <Route path=":groupId/edit" element={<EditGroupForm />} />
          </Route>

          <Route path="models">
            {/* List models */}
            <Route index element={<Models />} />

            <Route
              path=":modelId/transactions"
              element={<ModelDetail view="transactions" />}
            />

            {/* New transaction from Model */}
            <Route
              path=":modelId/transactions/new"
              element={<TransactionForm activeTab="new" />}
            />

            <Route
              path=":modelId/settings"
              element={<ModelDetail view="settings" />}
            />
          </Route>

          {/* Create new transaction */}

          <Route path="transactions">
            <Route
              path="new" //?type=in|out|transfer
              element={<TransactionForm activeTab="new" />}
            />

            {/* <Route
              path=":transactionId/edit"
              element={<TransactionForm type="income" activeTab="new" />}
            /> */}
          </Route>

          <Route path="vaults">
            <Route
              path="groups/new"
              element={<Creategroup groupType="vault" />}
            />
            {/* New vault */}
            <Route path="new" element={<AddVaultForm />} />
            <Route path=":vaultId">
              {/* Edit vault */}
              <Route path="edit" element={<EditVaultForm />} />

              <Route path="transactions">
                <Route index element={<TransactionForm activeTab="list" />} />
                <Route
                  path="new"
                  element={<TransactionForm activeTab="new" />}
                />
                <Route
                  path=":transactionId/edit"
                  element={<TransactionForm activeTab="new" />}
                />
              </Route>
            </Route>
            <Route
              path=":vaultId"
              element={<TransactionForm type="transfer" activeTab="list" />}
            />
          </Route>

          <Route path="categories">
            <Route
              path="groups/new"
              element={<Creategroup groupType="transactionCategory" />}
            />

            {/* Create new category */}
            <Route
              path="new" //?type="in|out"
              element={<AddTransactionCategoryForm />}
            />

            <Route path=":categoryId">
              {/* Edit category */}
              <Route path="edit" element={<EditTransactionCategoryForm />} />
              {/* ?offset=x */}
              <Route path="transactions">
                {/* List category transactions */}
                <Route index element={<TransactionForm activeTab="list" />} />
                <Route
                  path="new"
                  element={<TransactionForm activeTab="new" />}
                />
                <Route
                  path=":transactionId/edit"
                  element={<TransactionForm activeTab="new" />}
                />
              </Route>
            </Route>
          </Route>

          {/* <Route index element={<LayoutHome home />} /> */}
        </Route>
        {/* <Route element={<Layout />}>
          <Route index element={<HomePage />} />
          <Route path="about" element={<AboutPage />} />
          <Route path="playground" element={<PlaygroundPage />} />
        </Route> */}
      </Route>

      <Route element={<PrivateRoute />}>
        <Route path="private" element={<PlaygroundPage />} />
      </Route>
      <Route element={<LoginRoute />}>
        <Route path="login" element={<LoginPage />} />
      </Route>
      <Route path="logout" element={<LogoutPage />} />
      <Route path="forgot-password" element={<ForgotPasswordPage />} />
      <Route path="reset-password" element={<ResetPasswordPage />} />
      <Route path="register">
        <Route index element={<RegisterPage />} />
        <Route path="email" element={<RegisterWithEmailPage />} />
      </Route>
      <Route path="billing" element={<SubscriptionPage />} />
    </Route>,
  ),
)
